<template>
  <el-row>
    <el-card shadow="none"
             class="form-card mb-15">
      <el-form :inline="true"
               :model="searchForm"
               ref="search_form"
               class="search-form">
        <el-form-item label="员工卡号:"
                      prop="no">
          <el-input v-model.trim="searchForm.no"
                    placeholder="员工卡号"></el-input>
        </el-form-item>
        <el-form-item label="员工姓名:"
                      prop="person_name">
          <el-input v-model.trim="searchForm.person_name"
                    placeholder="员工姓名"></el-input>
        </el-form-item>
        <el-form-item label="房间:"
                      prop="room_name">
          <el-input v-model.trim="searchForm.room_name"
                    placeholder="房间"></el-input>
        </el-form-item>
        <el-form-item label="设备名称:"
                      prop="lock_name">
          <el-input v-model.trim="searchForm.lock_name"
                    placeholder="设备名称"></el-input>
        </el-form-item>
        <!-- 操作状态 0-待发送 1-成功 2-发送中 3-失败 -->
        <el-form-item label="操作结果:"
                      prop="oper_stat">
          <el-select v-model="searchForm.oper_stat"
                     placeholder="操作结果">
            <el-option label="全部"
                       value=""></el-option>
            <el-option label="待发送"
                       value="0"></el-option>
            <el-option label="成功"
                       value="1"></el-option>
            <el-option label="发送中"
                       value="2"></el-option>
            <el-option label="失败"
                       value="3"></el-option>
            <el-option label="超次"
                       value="4"></el-option>
            <el-option label="忽略"
                       value="5"></el-option>
          </el-select>
        </el-form-item>
        <!-- <el-form-item label="所属区域："
                      prop="area_id">
          <el-select v-model="searchForm.area_id"
                     placeholder="请选择所属区域">
            <el-option v-for="item in areaList"
                       :key="item.id"
                       :label="item.name"
                       :value="item.id">
            </el-option>
          </el-select>
        </el-form-item> -->
        <el-form-item label="日期范围:">
          <el-date-picker v-model="searchForm.time"
                          value-format="yyyy-MM-dd"
                          type="daterange"
                          start-placeholder="开始日期"
                          end-placeholder="结束日期">
          </el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-button type="primary"
                     icon="el-icon-search"
                     @click="searchSubmit('search_form')">查询
          </el-button>
          <el-button icon="el-icon-refresh"
                     @click="resetForm('search_form')">重置
          </el-button>
        </el-form-item>
      </el-form>
    </el-card>
    <el-row>
      <el-button v-has="'/auth_record/redo'"
                 type="primary"
                 @click="multipleRedo">批量重发</el-button>
    </el-row>
    <el-card shadow="none"
             class="mt-15">
      <el-table max-height="575"
                ref="multipleTable"
                :row-class-name="tableRowClassName"
                :data="tableData"
                @selection-change="handleSelectionChange">
        <el-table-column type="selection"
                         width="60"> </el-table-column>
        <el-table-column type="index"
                         label="序号"
                         width="60"></el-table-column>
        <el-table-column v-for="(item, index) in tableTitle"
                         :key="index"
                         :label="item.name"
                         :prop="item.prop"
                         :min-width="item.width"
                         :show-overflow-tooltip="true">
        </el-table-column>
        <el-table-column fixed="right"
                         label="操作"
                         width="80">
          <template slot-scope="scope">
            <el-button v-has="'/auth_record/redo'"
                       v-if="scope.row.oper_stat == 3 || scope.row.oper_stat == 4"
                       plain
                       size="mini"
                       type="primary"
                       @click="handleRedo(scope.row)">重发</el-button>
          </template>
        </el-table-column>
      </el-table>
      <Pagination :total="pagination.total"
                  :pageSize="pagination.perPage"
                  @handleSizeChange="handleSizeChange"
                  @handleCurrent="handleCurrentChange"></Pagination>
    </el-card>
  </el-row>
</template>

<script>
import fetch from '@/common/api'
import Pagination from '@/components/pagination/Pagination'
export default {
  components: { Pagination },
  data() {
    return {
      areaList: [],
      tmpArr: [],
      searchForm: {
        no: '',
        person_name: '',
        room_name: '',
        lock_name: '',
        oper_stat: '',
        area_id: '',
        time: []
      },
      tableTitle: [
        {
          prop: 'person_no',
          name: '员工卡号',
          width: '120'
        },
        {
          prop: 'person_name',
          name: '姓名',
          width: '100'
        },
        {
          prop: 'lock_name',
          name: '设备名称',
          width: '80'
        },
        {
          prop: 'slot_name',
          name: '时间组',
          width: '80'
        },
        {
          prop: 'lock_sn',
          name: '设备SN',
          width: '80'
        },
        {
          prop: 'room_name',
          name: '房间',
          width: '80'
        },
        {
          prop: 'med_type',
          name: '介质类型',
          width: '80'
        },
        {
          prop: 'med_value',
          name: '介质内容',
          width: '100'
        },
        {
          prop: 'oper_type',
          name: '操作类型',
          width: '80'
        },
        {
          prop: 'oper_statTxt',
          name: '操作结果',
          width: '120'
        },
        {
          prop: 'oper_time',
          name: '操作时间',
          width: '160'
        },
        {
          prop: 'create_time',
          name: '创建时间',
          width: '160'
        }
      ],
      tableData: [],
      // 分页相关
      pagination: {
        total: 0,
        currentPage: 1,
        perPage: 10
      },
      // 选中数据
      multipleSelection: []
    }
  },
  created() {
    this.getList()
    // this.getAreaTree()
  },
  methods: {
    // 获取列表
    getList() {
      const { perPage, currentPage } = this.pagination
      const { searchForm } = this
      let datas = {
        no: searchForm.no,
        person_name: searchForm.person_name,
        room_name: searchForm.room_name,
        lock_name: searchForm.lock_name,
        oper_stat: searchForm.oper_stat,
        // area_id: searchForm.area_id,
        startTime: searchForm.time.length ? searchForm.time[0] : '',
        endTime: searchForm.time.length ? searchForm.time[1] : ''
      }
      fetch
        .getAuthRecordList({
          perPage: perPage,
          currentPage: currentPage,
          ...datas
        })
        .then((data) => {
          data.procData(
            data.res,
            (data) => {
              this.pagination.total = Number(data.total)
              this.tableData = data.list.map((item) => {
                item.oper_statTxt =
                  item.oper_stat === '1'
                    ? '成功'
                    : item.oper_stat === '2'
                    ? '发送中'
                    : item.oper_stat === '3'
                    ? '失败'
                    : item.oper_stat === '4'
                    ? '超次'
                    : item.oper_stat === '5'
                    ? '忽略'
                    : '待发送'
                return item
              })
            },
            (err) => {
              this.$message.error(err)
            }
          )
        })
    },
    // 获取数据
    getAreaTree() {
      fetch.getAreaTree({}).then((data) => {
        data.procData(
          data.res,
          (data) => {
            this.tmpArr = []
            this.areaList = this.titleFormat(data.treeData, '• ')
          },
          (err) => {
            this.$message.error(err)
          }
        )
      })
    },
    //  格式化名称
    titleFormat(data, prefix) {
      if (data.length === 0) {
        return []
      }
      data.forEach((item) => {
        let tmp = item
        tmp.name = prefix + item.name
        this.tmpArr.push(tmp)
        if (item.children && item.children.length > 0) {
          this.titleFormat(item.children, '• ' + prefix)
        }
      })
      return this.tmpArr
    },
    // 搜索提交
    searchSubmit() {
      this.pagination.perPage = 10
      this.pagination.currentPage = 1
      this.getList()
    },
    resetForm(formName) {
      this.pagination.perPage = 10
      this.pagination.currentPage = 1
      this.searchForm.time = []
      this.$refs[formName].resetFields()
      this.getList()
    },
    // 分页
    handleSizeChange(val) {
      this.pagination.perPage = val
      this.pagination.currentPage = 1
      this.getList()
    },
    handleCurrentChange(val) {
      this.pagination.currentPage = val
      this.getList()
    },
    // 选择变化
    handleSelectionChange(val) {
      this.multipleSelection = val
    },
    // 重发
    handleRedo(data) {
      this.$confirm('是否确定重新下发?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          this.redoAuth(data.id)
        })
        .catch(() => {})
    },
    multipleRedo() {
      if (this.multipleSelection.length > 0) {
        this.$confirm('是否确定重新下发选中的数据?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })
          .then(() => {
            let selectIds = this.multipleSelection
              .map((item) => {
                return item.id
              })
              .join(',')
            this.redoAuth(selectIds)
          })
          .catch(() => {})
      } else {
        this.$message.warning('请选择需要重新下发的记录后重试')
      }
    },
    redoAuth(ids) {
      fetch
        .redoAuth({
          id: ids
        })
        .then((data) => {
          data.procData(
            data.res,
            (data) => {
              if (Number(data.operationResult) === 1) {
                this.$message.success('操作成功')
              } else {
                this.$message.success('操作失败')
              }
              this.getList()
            },
            (err) => {
              this.$message.error(err)
            }
          )
        })
    },
    tableRowClassName({ row }) {
      if (row.oper_stat === '1') {
        return 'succes-row'
      } else if (row.oper_stat === '2') {
        return 'error-row'
      } else if (row.oper_stat === '5') {
        return 'succes-row'
      }
      return 'error-row'
    }
  }
}
</script>

<style lang="less">
.el-table .succes-row {
  background: rgba(103, 194, 58, 0.2);
}
.el-table .error-row {
  background: rgba(245, 108, 108, 0.2);
}
</style>
